import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router} from '@angular/router';
import {StateService} from '../state.service';
import {Injectable} from '@angular/core';

@Injectable()
export class AdminGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private state: StateService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.state.snapshot.auth.isAdmin;
  }

  canLoad(route: Route): boolean {
    return this.state.snapshot.auth.isAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/guard/admin-guard.ts